import { Component, ChangeDetectionStrategy, Input, ViewChild, input, signal } from '@angular/core';
import { StockInfo } from '@pedix-workspace/shared-stock';

import { TranslocoDirective } from '@jsverse/transloco';
import { ModalDialogComponent } from '@pedix-workspace/angular-ui-modal';
import { IconAlertComponent } from '@pedix-workspace/angular-ui-icons';

@Component({
    selector: 'pxw-coupon-validation-errors-dialog',
    templateUrl: './coupon-validation-errors-dialog.component.html',
    styleUrls: ['./coupon-validation-errors-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TranslocoDirective, ModalDialogComponent, IconAlertComponent]
})
export class CouponValidationErrorsDialogComponent {
  @ViewChild(ModalDialogComponent) modalDialog: ModalDialogComponent;

  couponValidationErrors = signal<string[]>([]);

  open(couponValidationErrors: string[]) {
    this.couponValidationErrors.set(couponValidationErrors);

    return this.modalDialog.open().catch(() => {});
  }
}
